/* tslint:disable */
require('./BaseTextRenderer.module.css');
const styles = {
  ellipsis: 'ellipsis_79cb037e',
  relative: 'relative_79cb037e',
  baseText: 'baseText_79cb037e',
  fabricIcon: 'fabricIcon_79cb037e',
};

export default styles;
/* tslint:enable */